
export default function CaseStudies() {
  const cases = [
    {
      industry: '自動車Tier1',
      results: [
        '交換時間70%削減',
        '停止5%削減',
        '年1000万円効果'
      ],
      image: 'https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/8198d6a6012fb82fbfa99b53325c91af.png',
      color: 'yellow'
    },
    {
      industry: '航空（難削材）',
      results: [
        'ppm大幅改善',
        '作業時間大幅減',
        '監査資料作成短時間化'
      ],
      image: 'https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/171d0b913c9f13640a08180fc5103232.png',
      color: 'gray'
    }
  ];

  return (
    <section id="cases" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            【モデルケース（イメージ）】
          </h2>
          <p className="text-xl text-gray-600">
            実際の導入効果をご紹介
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {cases.map((caseStudy, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg border border-gray-200">
              <div className="relative h-64">
                <img 
                  src={caseStudy.image}
                  alt={caseStudy.industry}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <h3 className="text-2xl font-bold text-white">
                    {caseStudy.industry}
                  </h3>
                </div>
              </div>
              
              <div className="p-8">
                <h4 className="text-lg font-semibold text-gray-900 mb-4">
                  導入効果
                </h4>
                <div className="space-y-3">
                  {caseStudy.results.map((result, resultIndex) => (
                    <div key={resultIndex} className="flex items-center space-x-3">
                      <div className={`w-3 h-3 bg-${caseStudy.color}-500 rounded-full flex-shrink-0`}></div>
                      <span className="text-gray-700 font-medium">{result}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-2xl p-8 mb-8 border border-gray-300">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              より詳細な導入事例をご希望の方
            </h3>
            <p className="text-gray-600 mb-6">
              業界別・用途別の詳細事例資料を準備でき次第、優先的にお送りします
            </p>
            <button className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors cursor-pointer whitespace-nowrap">
              導入事例を先行受取
            </button>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-car-line text-2xl text-yellow-600"></i>
              </div>
              <h4 className="font-semibold text-yellow-800 mb-2">自動車業界</h4>
              <p className="text-yellow-700 text-sm">
                Tier1〜Tier3まで幅広い導入実績
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-plane-line text-2xl text-gray-600"></i>
              </div>
              <h4 className="font-semibold text-gray-800 mb-2">航空宇宙</h4>
              <p className="text-gray-700 text-sm">
                難削材加工での品質安定化
              </p>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-2xl text-yellow-600"></i>
              </div>
              <h4 className="font-semibold text-yellow-800 mb-2">金型・建機</h4>
              <p className="text-yellow-700 text-sm">
                多品種少量生産での効率化
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
